import {Injectable} from '@angular/core';
import {SceneService} from '../3DView/Scene/scene.service';
import {GLTFExporter} from 'three/examples/jsm/exporters/GLTFExporter';


@Injectable({
    providedIn: 'root'
})
export class GltfExporterService {
    private readonly link: any;
    private options = {
        trs: false,
        onlyVisible: true,
        truncateDrawRange: true,
        binary: false,
        forcePowerOfTwoTextures: false,
        maxTextureSize: 4096
    };

    constructor(private sceneService: SceneService) {
        this.link = document.createElement('a');
        this.link.style.display = ' none';
        document.body.appendChild(this.link);
    }

    public exportGLTF(): void {
        const exporter = new GLTFExporter();
        exporter.parse(this.sceneService.scene, (gltf) => {
            if (gltf instanceof ArrayBuffer) {

                this.saveArrayBuffer(gltf, 'surface3D.glb');

            } else {

                const output = JSON.stringify(gltf, null, 2);
                this.saveString(output, 'surface3D.gltf');

            }

        }, this.options);
    }

    private saveArrayBuffer(buffer, filename: string): void {
        this.save(new Blob([buffer], {type: 'application/octet-stream'}), filename);
    }

    private saveString(text, filename: string): void {
        this.save(new Blob([text], {type: 'text/plain'}), filename);
    }

    private save(blob, filename): void {
        this.link.href = URL.createObjectURL(blob);
        this.link.download = filename;
        this.link.click();
    }
}
